export default __webpack_public_path__ + "static/media/mob_dark_iusd.e5018d14.png";